/*
 * Deletes a catalog type from API,
 * optionally removes it fromthe vuex store
 *
 * Usage: catalogService.delete('highway')
 *          .then(=> ...)
 * 
 * Vuex integration: catalogService.delete('highway', {useStore: true})
 */

import Vue from 'vue'
import store from './../../store'

const success = function (payload) {
  store.dispatch('catalogs/delete', payload)
}

const failure = function(payload) {
}

const deleteFromSource = function(source, data) {
  let index = source.indexOf(data)

  if (index === -1) {
    return
  }

  source.splice(index, 1)
}

export default (catalog, payload, options={}) => {
	const source = options.source
  return Vue.$http.delete(`/catalogs/${catalog}/${payload.id}/`, payload)
    .then(response => {
    	if (options.useStore) {
    		success( { type: catalog, data: payload } )
    	}

    	if (source) {
    		deleteFromSource(source, payload)
    	}

      return response
    }).catch((error) => {
      failure(error)
      throw error
    })
}


// WEBPACK FOOTER //
// ./src/services/catalog/delete.js